export default __webpack_public_path__ + "static/media/twitterCircleWhite.0e58c368.svg";